import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { WebShopType } from '../Enums/WebShopType.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputWebShopDefinition<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: any;
  /** Alias: name */
  name?: any;
  /** Alias: url */
  url?: any;
  /** Alias: userName */
  userName?: any;
  /** Alias: customerNumber */
  customerNumber?: any;
  /** Alias: password */
  password?: any;
  /** Alias: sDObjMembercode */
  sDObjMembercode?: any;
  /** Alias: shopType */
  shopType?: WebShopType;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputWebShopDefinition> = {
  id: {
    alias: 'id',
  },
  name: {
    alias: 'name',
  },
  url: {
    alias: 'url',
  },
  userName: {
    alias: 'userName',
  },
  customerNumber: {
    alias: 'customerNumber',
  },
  password: {
    alias: 'password',
  },
  sDObjMembercode: {
    alias: 'sDObjMembercode',
  },
  shopType: {
    alias: 'shopType',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputWebShopDefinitionEntityDefinition: EntitiyDefinition<InputWebShopDefinition> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputWebShopDefinition',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
